<div class="modal-header">
  <button
    type="button"
    class="close pull-right"
    (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="modal-body__title">
    Занятие
  </div>
  <div class="modal-body__lesson">
    <div class="modal-body__lesson-info">
      Шк <span class="bold">{{ school?.title }}</span>
    </div>
    <div class="modal-body__lesson-info">
      <span class="bold">{{ lesson.student_class.title }}</span> класс
    </div>
    <div class="modal-body__lesson-info">
      <span class="bold">{{ lesson.subject.title }}</span>
    </div>
    <div class="modal-body__lesson-info">
      Занятие № {{ lesson.lesson_number }}
    </div>
    <div class="modal-body__lesson-info">
      {{ (lesson.start_time ? lesson.start_time : lesson.date) | date: 'dd.MM.yyyy' }}
    </div>
  </div>

  <div class="modal-body__description">
      <span class="modal-body__lesson-title" *ngIf="lesson.title">
        {{ lesson.title }}
      </span>
    <span class="modal-body__lesson-remarks" *ngIf="lesson.remarks">
        {{ lesson.remarks }}
      </span>
  </div>
  <button
    class="modal-body__button modal-body__button_large modal-body__button_danger"
    (click)="changeLessonStatusInWork()">
    Вернуться к проведению занятия
  </button>
</div>
